module.exports = __webpack_public_path__ + "img/servicefee-banner-jp.620267e.png";